module.exports = __webpack_public_path__ + "img/noise.65f9c60f.svg";